import FetchAiCostLimitSubjects from '@Application/AiCostLimits/Subjects/Queries/FetchAiCostLimitSubjects';
import fetchAiCostLimitSubjects from '@Application/AiCostLimits/Subjects/fetchAiCostLimitSubjects';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/** Reads the structures and facilities a limit can bound, fetching them when the store holds none for the account. */
const useAiCostLimitSubjects = (accountId: number | null, isEnabled = true) => {
	const dispatch = useDispatch();
	const enabled = isEnabled && accountId !== null;

	return useStoreQuery({
		selector: (state) => state.aiCostLimitsStore.subjects,
		stopOn: (value) => !enabled || (value !== null && value.accountId === accountId),
		query: () => {
			if (!enabled) {
				return Promise.resolve();
			}

			return dispatch(fetchAiCostLimitSubjects(new FetchAiCostLimitSubjects(accountId)));
		},
		deps: [accountId, enabled],
	});
};

export default useAiCostLimitSubjects;
